import { resolveMediaDomainImageUrl } from '@pm2/common-utils';
import { preloadImage } from '@utils/common';

const PRELOAD_TIMEOUT_MS = 1_500;
async function preloadPortalImages(portals) {
  await Promise.all(portals.map(portal => new Promise(resolve => {
    const src = getPortalImageUrl(portal);
    if (!src) {
      resolve(undefined);
      return;
    }
    setTimeout(() => {
      resolve(undefined);
    }, PRELOAD_TIMEOUT_MS);
    preloadImage(src).finally(() => resolve(undefined));
  })));
}
function getPortalImageUrl(portal) {
  return resolveMediaDomainImageUrl(portal.thumbnail, 71);
}

export { getPortalImageUrl, preloadPortalImages };
//# sourceMappingURL=util.preload-portal-images.js.map
